<div class="associations-container dark-mode">
    <div class="page-header mt-5">
        <div class="d-flex">
            <mat-icon class="back-button" (click)="goBack()">chevron_left</mat-icon>
            <h1 class="page-title">New Cyber Combine: Scorecard</h1>
        </div>
        <div class="breadcrumb">
            <span class="breadcrumb-item">Dashboard</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-item" [routerLink]="'/office/user'">User</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-current">{{user?.email}}</span>
        </div>
    </div>

    <hr class="mb-3" />

    <form [formGroup]="form">
        <div class="row my-3">
            <div class="col-12 col-sm-12 col-md-4">
                <mat-form-field class="full-width w-100" appearance="outline">
                    <mat-label>User Name</mat-label>
                    <input readonly matInput formControlName="userName">
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-12 col-md-4">
                <mat-form-field class="full-width w-100" appearance="outline">
                    <mat-label>Date</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="assessmentDate">
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-12 col-md-4">
                <mat-form-field class="full-width w-100" appearance="outline" >
                    <mat-label>Competition Level</mat-label>
                    <mat-select formControlName="competitionLevel">
                        <mat-option *ngFor="let param of competitionLevels.parameterMembers" [value]="param.parameterValue">
                            {{ param.parameterLabel }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <mat-card class="card-bg-20">
            <mat-card-content>
                <h5 class="my-3">Individual Challenge Scorecard</h5>
                <div class="table-responsive-dark list-wrapper-bordered-dark d-none d-sm-none d-md-none d-lg-block">
                    <table class="table table-striped table-hover table-bordered">
                        <thead>
                        <tr>
                            <th>Challenge Name</th>
                            <th>Accuracy (%)</th>
                            <th>Competency (%)</th>
                            <th>Rank Level</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let s of scorecards; let i = index">
                            <td>
                                <mat-form-field class="full-width w-100" appearance="outline">
                                    <input matInput
                                           [(ngModel)]="s.challengeName"
                                           [ngModelOptions]="{standalone: true}"
                                           placeholder="Challenge Name">
                                </mat-form-field>
                            </td>
                            <td>
                                <mat-form-field class="full-width w-100" appearance="outline">
                                    <input class="text-end"
                                           type="text"
                                           mask="separator" thousandSeparator="," decimalMarker="."
                                           matInput
                                           [(ngModel)]="s.accuracy"
                                           [ngModelOptions]="{standalone: true}"
                                           placeholder="Accuracy (%)">
                                    <span class="p-4" matSuffix>%</span>
                                </mat-form-field>
                            </td>
                            <td>
                                <mat-form-field class="full-width w-100" appearance="outline">
                                    <input class="text-end"
                                           type="text"
                                           mask="separator" thousandSeparator="," decimalMarker="."
                                           matInput
                                           [(ngModel)]="s.competency"
                                           [ngModelOptions]="{standalone: true}"
                                           placeholder="Competency (%)">
                                    <span class="p-4" matSuffix>%</span>
                                </mat-form-field>
                            </td>
                            <td>
                                <mat-form-field class="full-width w-100" appearance="outline">
                                    <input
                                            matInput
                                            [(ngModel)]="s.rankLevel"
                                            [ngModelOptions]="{standalone: true}"
                                            placeholder="Rank Level">
                                </mat-form-field>
                            </td>
                            <td>
                                <button (click)="deleteScorecard(s, i)" class="crimson-red" mat-icon-button aria-label="delete scorecard">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </td>
                        </tr>
                        </tbody>
                        <tfoot>
                        <tr>
                            <td [colSpan]="5" class="text-center card-bg-20">
                                <button type="button" (click)="addScorecard()" mat-raised-button aria-label="add scorecard" class="bg-accent-orange">
                                    <mat-icon>add</mat-icon>Add Another Challenge
                                </button>
                            </td>
                        </tr>
                        </tfoot>
                    </table>
                </div>
                <div class="d-block d-sm-block d-md-block d-lg-none">
                    <div class="row mt-3 border-bottom" *ngFor="let s of scorecards; let i = index">
                        <div class="col-12 d-flex justify-content-between pb-2">
                            <span class="d-block p-2">No.{{i + 1}}</span>
                            <button (click)="deleteScorecard(s, i)" style="color:#5B25B4" mat-raised-button aria-label="delete scorecard">
                                <mat-icon>delete</mat-icon> Delete
                            </button>
                        </div>
                        <div class="col-12">
                            <mat-form-field class="full-width w-100" appearance="outline">
                                <mat-label>Challenge Name</mat-label>
                                <input matInput
                                       [(ngModel)]="s.challengeName"
                                       [ngModelOptions]="{standalone: true}"
                                       placeholder="Challenge Name">
                            </mat-form-field>
                        </div>
                        <div class="col-12">
                            <mat-form-field class="full-width w-100" appearance="outline">
                                <mat-label>Accuracy (%)</mat-label>
                                <input class="text-end"
                                       type="text"
                                       mask="separator" thousandSeparator="," decimalMarker="."
                                       matInput
                                       [(ngModel)]="s.accuracy"
                                       [ngModelOptions]="{standalone: true}"
                                       placeholder="Accuracy (%)">
                                <span class="p-4" matSuffix>%</span>
                            </mat-form-field>
                        </div>
                        <div class="col-12">
                            <mat-form-field class="full-width w-100" appearance="outline">
                                <mat-label>Competency (%)</mat-label>
                                <input class="text-end"
                                       type="text"
                                       mask="separator" thousandSeparator="," decimalMarker="."
                                       matInput
                                       [(ngModel)]="s.competency"
                                       [ngModelOptions]="{standalone: true}"
                                       placeholder="Competency (%)">
                                <span class="p-4" matSuffix>%</span>
                            </mat-form-field>
                        </div>
                        <div class="col-12">
                            <mat-form-field class="full-width w-100" appearance="outline">
                                <mat-label>Rank Level</mat-label>
                                <input
                                        matInput
                                        [(ngModel)]="s.rankLevel"
                                        [ngModelOptions]="{standalone: true}"
                                        placeholder="Rank Level">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-12">
                            <button type="button" (click)="addScorecard()" mat-raised-button aria-label="add scorecard" style="background:#5B25B4; color: #fff;">
                                <mat-icon>add</mat-icon>Add Another Challenge
                            </button>
                        </div>
                    </div>
                </div>


            </mat-card-content>
        </mat-card>

        <mat-card class="mt-3 card-bg-20">
            <mat-card-content >
                <h5 class="my-3">Challenge: Wide-Match</h5>
                <div class="table-responsive-dark list-wrapper-bordered-dark d-none d-sm-none d-md-none d-lg-block">
                    <table class="table table-striped table-hover table-bordered">
                        <thead>
                        <tr>
                            <th>Challenge Name</th>
                            <th>Average Accuracy (%)</th>
                            <th>Average Competency (%)</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let s of wideMatch; let i = index">
                            <td>
                                <mat-form-field class="full-width w-100" appearance="outline">
                                    <input
                                            matInput
                                            [(ngModel)]="s.challengeName"
                                            [ngModelOptions]="{standalone: true}"
                                            placeholder="Challenge Name">
                                </mat-form-field>
                            </td>
                            <td>
                                <mat-form-field class="full-width w-100" appearance="outline">
                                    <input class="text-end"
                                           matInput
                                           type="text"
                                           mask="separator" thousandSeparator="," decimalMarker="."
                                           [(ngModel)]="s.averageAccuracy"
                                           [ngModelOptions]="{standalone: true}"
                                           placeholder="Average Accuracy (%)">
                                    <span class="p-4" matSuffix>%</span>
                                </mat-form-field>
                            </td>
                            <td>
                                <mat-form-field class="full-width w-100" appearance="outline">
                                    <input class="text-end"
                                           matInput
                                           type="text"
                                           mask="separator" thousandSeparator="," decimalMarker="."
                                           [(ngModel)]="s.averageCompetency"
                                           [ngModelOptions]="{standalone: true}"
                                           placeholder="Average Competency (%)">
                                    <span class="p-4" matSuffix>%</span>
                                </mat-form-field>
                            </td>
                            <td>
                                <button (click)="deleteWideMatch(s, i)" class="crimson-red" mat-icon-button aria-label="delete wide match">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </td>
                        </tr>
                        </tbody>
                        <tfoot>
                        <tr>
                            <td [colSpan]="5" class="text-center card-bg-20">
                                <button type="button" (click)="addWideMatch()" mat-raised-button aria-label="add add wide match" class="bg-accent-orange">
                                    <mat-icon>add</mat-icon>Add Another Challenge
                                </button>
                            </td>
                        </tr>
                        </tfoot>
                    </table>
                </div>
                <div class="d-block d-sm-block d-md-block d-lg-none">
                    <div class="row mt-3 border-bottom" *ngFor="let w of wideMatch; let i = index">
                        <div class="col-12 d-flex justify-content-between pb-2">
                            <span class="d-block p-2">No. {{i + 1}}</span>
                            <button (click)="deleteWideMatch(w, i)" style="color:#5B25B4" mat-raised-button aria-label="delete scorecard">
                                <mat-icon>delete</mat-icon> Delete
                            </button>
                        </div>
                        <div class="col-12">
                            <mat-form-field class="full-width w-100" appearance="outline">
                                <mat-label>Challenge Name</mat-label>
                                <input matInput
                                       [(ngModel)]="w.challengeName"
                                       [ngModelOptions]="{standalone: true}"
                                       placeholder="Challenge Name">
                            </mat-form-field>
                        </div>
                        <div class="col-12">
                            <mat-form-field class="full-width w-100" appearance="outline">
                                <mat-label>Average Accuracy (%)</mat-label>
                                <input class="text-end"
                                       type="text"
                                       mask="separator" thousandSeparator="," decimalMarker="."
                                       matInput
                                       [(ngModel)]="w.averageAccuracy"
                                       [ngModelOptions]="{standalone: true}"
                                       placeholder="Accuracy (%)">
                                <span class="p-4" matSuffix>%</span>
                            </mat-form-field>
                        </div>
                        <div class="col-12">
                            <mat-form-field class="full-width w-100" appearance="outline">
                                <mat-label>Average Competency (%)</mat-label>
                                <input class="text-end"
                                       type="text"
                                       mask="separator" thousandSeparator="," decimalMarker="."
                                       matInput
                                       [(ngModel)]="w.averageCompetency"
                                       [ngModelOptions]="{standalone: true}"
                                       placeholder="Competency (%)">
                                <span class="p-4" matSuffix>%</span>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-12">
                            <button type="button" (click)="addWideMatch()" mat-raised-button aria-label="add scorecard" style="background:#5B25B4; color: #fff;">
                                <mat-icon>add</mat-icon>Add Another Challenge
                            </button>
                        </div>
                    </div>
                </div>

            </mat-card-content>
        </mat-card>
        <div class="row my-3">
            <div class="col-12">
                <mat-form-field class="full-width w-100" appearance="outline">
                    <mat-label>Combine Assessment</mat-label>
                    <textarea
                            matInput
                            formControlName="summary"
                            placeholder="Provide a summary of the evaluation..."
                            cdkTextareaAutosize
                            cdkAutosizeMinRows="3"
                            cdkAutosizeMaxRows="5">
                </textarea>
                </mat-form-field>
            </div>
        </div>
        <div class="row my-3">
            <div class="col-12 text-end">
                <button (click)="resetForm()" mat-raised-button color="accent" style="margin-right: 10px;">
                    Reset
                </button>
                <button (click)="save()" mat-raised-button  class="bg-accent-orange">
                    Save
                </button>
            </div>
        </div>

    </form>
</div>


